import { Rewards } from '@arrived/models';

import { rewardsApi } from '../api';

export const getRewardsAccount = async (accountId: string) => {
  const response = await rewardsApi.get<Rewards.Account>(`/accounts/${accountId}`);
  return response.data;
};

export const getRewardsAccounts = async (filters?: Rewards.AccountFilters) => {
  const response = await rewardsApi.get<Rewards.AccountSearchResult>(`/accounts`, { params: filters });
  return response.data;
};

export const postRewardsAccount = async (accountBody: Rewards.AccountCreationRequest) => {
  const response = await rewardsApi.post<Rewards.Account>(`/accounts`, accountBody);
  return response.data;
};
